import { useEffect, useState, } from 'react';
import { SerializedError } from '@reduxjs/toolkit';

import { useAppDispatch } from '../../app/hooks';
import {
  getScopeAction,
} from './scopeSlice';
import { Scope } from '../../types';

type Props = {
  tenant_id: string;
  scope_name: string;
  closeCallback: (error?: SerializedError) => void;
};

export function ScopeView({ tenant_id, scope_name, closeCallback }: Props) {
  const dispatch = useAppDispatch();
  const [scope, setScope] = useState<Scope|undefined>();

  useEffect(() => {
    (async() => {
      let result = await dispatch(getScopeAction({ tenant_id, scope_name }));
      if (getScopeAction.fulfilled.match(result)) {
        setScope(result.payload);
      } else {
        closeCallback(result.error);
      }
    })();
  }, [tenant_id, scope_name, dispatch, closeCallback]);
  if (!scope) {
    return null;
  }
  return (
    <>
      <div className="mb-3 row">
        <label htmlFor="scope_id" className="col-sm-3 col-form-label">ScopeId</label>
        <div className="col-sm-6">
          <span id="scope_id" className="form-control-plaintext">{scope.scope_id}</span>
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="scope_name" className="col-sm-3 col-form-label">Name</label>
        <div className="col-sm-6">
          <span id="scope_name" className="form-control-plaintext">{scope.name}</span>
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="scope_title" className="col-sm-3 col-form-label">Title</label>
        <div className="col-sm-6">
          <span id="scope_title" className="form-control-plaintext">{scope.title}</span>
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="scope_description" className="col-sm-3 col-form-label">Description</label>
        <div className="col-sm-6">
          <span id="scope_description" className="form-control-plaintext">{scope.description}</span>
        </div>
      </div>
    </>
  );
}
